import React from 'react';
import PieChart from './pie-chart';

const sortValues = (values) => {
  values.sort((a, b) => {
    const rank = (v) => (v[1] === 'Yes' ? 0 : 1);
    const rankA = rank(a);
    const rankB = rank(b);
    if (rankA < rankB) return -1;
    if (rankA > rankB) return 1;
    return 0;
  });
  if (values.length > 1 && values[0][2] === 0 && values[1][2] === 0) {
    values[0][2] = 0.1;
  }
  return values;
};

const FiftyFifty = (props) => (
  <PieChart
    {...props}
    sortValues={sortValues}
    chartVariantClassName="pie-chart fifty-fifty"
  />
);

export default FiftyFifty;
